import {
    StarFilled,
    FileExclamationFilled,
    RightCircleOutlined,
    HomeFilled,
    CodeSandboxOutlined,
    BuildFilled,
    UserOutlined,
    ProjectFilled,
    CalendarFilled,
    PaperClipOutlined,
    ShrinkOutlined,
    NotificationOutlined,
    MedicineBoxOutlined,
    UndoOutlined,
    LoginOutlined, FileDoneOutlined,
    OrderedListOutlined,
    EnvironmentOutlined


} from '@ant-design/icons';

export const menuArray = [
    {name: "Platform Listesi", route:"/platforms", icon: <StarFilled />, roles: ["admin"], subMenuArray:[]},
    {name: "Müşteri Listesi", route:"/customers", icon: <BuildFilled />, roles: ["admin"] , subMenuArray:[]},
    {name: "Firma/Şube Listesi", route:"/companies", icon: <ProjectFilled />, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Kullanıcılar", route:"/users", icon: <UserOutlined/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Slider", route:"/activity", icon: <CalendarFilled/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Bildirim", route:"/news", icon: <PaperClipOutlined />, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Destek Talepleri", route:"/supports", icon: <MedicineBoxOutlined />, roles: ["admin"] , subMenuArray:[]},
    {name: "Yemek Fişi Yönetimi", route:"/food-ticket", icon: <FileDoneOutlined/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Yemek Listesi", route:"/food-list", icon: <OrderedListOutlined/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Yemek Fişi Yönetimi", route:"/food-ticket", icon: <FileDoneOutlined/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Roller", route:"/roles", icon: <ShrinkOutlined />, roles: ["admin"] , subMenuArray:[]},
    {name: "Loglar", route:"/logs", roles: ["admin"] , icon: <FileExclamationFilled />, subMenuArray:[]},
    {name: "Isı Haritası", route:"/map", roles: ["admin"] , icon: <FileExclamationFilled />, subMenuArray:[]},
    {name: "Hedef Lokasyonlar", route:"/target-locations", roles: ["admin", "customer"] , icon: <EnvironmentOutlined />, subMenuArray:[]},
    {name: "Giriş Çıkış Bilgileri", route:"/login-informations", icon: <LoginOutlined/>, roles: ["admin", "customer"] , subMenuArray:[]},
    {name: "Uygulama Yönetimi", route:"", icon: <CodeSandboxOutlined />, roles: ["admin"],
        subMenuArray:[
            {name: "Tanıtım", route:"/info", icon: <RightCircleOutlined/>},
            {name: "Ayarlar", route:"/app-config", icon: <RightCircleOutlined/>},
            {name: "Kullanıcı Sıfırla", route:"/user-restart", icon: <UndoOutlined />}
        ]
    },
]
